import React from "react";
import { Link } from "../../i18n/LangContext";
import { useTranslation } from "react-i18next";
import { localeFor } from "../../i18n";
import "../../styles/blog/StoryCard.css";
import { keepSuffixes } from "../../utils/typography";
import { categoryName } from "../../utils/categories";

const StoryCard = ({ post }) => {
  const { t, i18n } = useTranslation();
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(localeFor(i18n.language), {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Link to={`/stories/${post.slug}`} className="story-card-list">
      {post.featuredImage && (
        <div className="story-card-image">
          <img
            src={post.featuredImage}
            alt={post.title}
            loading="lazy"
          />
        </div>
      )}
      <div className="story-card-content">
        <div className="story-card-header">
          {post.category && (
            <span className="story-category">{categoryName(t, post.category)}</span>
          )}
          <span className="story-date">{formatDate(post.publishedAt)}</span>
        </div>
        <h3 className="story-title">{keepSuffixes(post.title)}</h3>
        <p className="story-excerpt">{post.excerpt}</p>
        <div className="story-card-footer">
          <div className="story-author">
            {post.author.avatar ? (
              <img
                src={post.author.avatar}
                alt={post.author.name}
                className="author-avatar"
                loading="lazy"
              />
            ) : (
              <div className="author-avatar-placeholder">
                {post.author.name.charAt(0).toUpperCase()}
              </div>
            )}
            <span className="author-name">{post.author.name}</span>
          </div>
          {post.readingTime && (
            <span className="story-reading-time">
              {t("stories.readingTime", { count: post.readingTime })}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default StoryCard;
